import { Box, Chip, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import { ICON_BUTTON_TYPE } from '../../../constants';
import IconButton from '../../../components/IconButton';
import TopBar from './TopBar';
import AddInsuranceModal from './AddInsuranceModal';
import {
  deleteUserHealthInsurance,
  getUserHealthInsurance,
  getHealthInsuranceApi,
  deleteHealthInsuranceApi,
} from '../../../utils/api';
import { isEmpty } from 'lodash';
import { useMutation, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

const HealthInsurance = ({ user, recipient }) => {
  const { t } = useTranslation();
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [activeEditData, setActiveEditData] = React.useState(null);

  const { data, isLoading, refetch } = useQuery(
    ['getUserHealthInsurance'],
    () =>
      recipient?._id
        ? getHealthInsuranceApi({ userId: user?._id, recipientId: recipient?._id })
        : getUserHealthInsurance({ userId: user?._id }),
    {
      retry: false,
      cacheTime: 0,
    },
  );

  const deleteInsuranceHandler = useMutation(recipient?._id ? deleteHealthInsuranceApi : deleteUserHealthInsurance, {
    onSuccess: async ({ data }) => {
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleDelete = (item) => {
    if (recipient?._id) {
      deleteInsuranceHandler.mutate({ userId: user?._id, recipientId: recipient?._id, insuranceId: item?._id });
    } else {
      deleteInsuranceHandler.mutate({ userId: user?._id, insuranceId: item?._id });
    }
  };

  return (
    <Grid sx={{ paddingBottom: { xs: '200px', sm: 0 } }}>
      <TopBar onClick={() => setShowAddModal(true)} btnText={t('addInsurance')} />

      {isLoading && (
        <Grid marginY={10} container justifyContent={'center'}>
          <CircularProgress size={40} style={{ color: '#26786a' }} />
        </Grid>
      )}

      {!isLoading && isEmpty(data?.data) && (
        <Typography variant="h5" textAlign="center">
          {t('noInsurancesFound')}
        </Typography>
      )}

      {!isLoading &&
        !isEmpty(data?.data) &&
        data?.data.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              padding: '18px',
              backgroundColor: 'rgba(255, 255, 255, 1)',
              borderRadius: '20px',
              gap: '15px',
              marginBottom: '20px',
              mt: 2,
              '@media (max-width: 600px)': {
                width: '95%',
                flexDirection: 'column',
                height: 'auto',
                mt: 2,
              },
            }}
          >
            <Grid container justifyContent="space-between" alignItems="center" sx={{ height: '60px' }}>
              <img src={item?.imageUrl} alt={item?.title} style={{ width: '152px', height: 'auto' }} />
              <IconButton type={ICON_BUTTON_TYPE.delete} onClick={() => handleDelete(item)} />
            </Grid>

            <Divider sx={{ width: '100%' }} />

            <Grid container sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
              {[
                { label: t('memberId'), value: item?.member },
                { label: t('groupNumber'), value: item?.group },
                { label: t('bin'), value: item?.bin },
                { label: t('benefitPlan'), value: item?.benefitPlan },
                { label: t('plan'), value: item?.plan },
                { label: t('effectiveDate'), value: item?.date },
              ].map((item, index) => (
                <Grid item key={index}>
                  <Typography variant="body2" color="textSecondary">
                    {item.label}
                  </Typography>
                  <Typography variant="body1" color="textPrimary">
                    {item.value}
                  </Typography>
                </Grid>
              ))}
            </Grid>

            <Divider sx={{ width: '100%' }} />

            <Grid container sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
              <Grid item>
                <Typography variant="body2" color="textSecondary">
                  {t('dependents')}
                </Typography>
                <Grid container spacing={1}>
                  {item?.dependents.map((name, index) => (
                    <Grid item key={index}>
                      <Chip
                        label={name}
                        sx={{
                          backgroundColor: 'rgba(245, 245, 247, 1)',
                          color: 'rgba(29, 29, 31, 1)',
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid item>
                <Typography variant="body2" color="textSecondary">
                  {t('prices')}
                </Typography>
                <Grid container spacing={1}>
                  {item?.prices.map((price, index) => (
                    <Grid item key={index}>
                      <Chip
                        label={price}
                        sx={{
                          backgroundColor: 'rgba(245, 245, 247, 1)',
                          color: 'rgba(29, 29, 31, 1)',
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        ))}
      <AddInsuranceModal
        show={showAddModal}
        onClose={() => {
          setShowAddModal(false);
          setActiveEditData(null);
        }}
        recipient={recipient}
        refetch={refetch}
        activeEditData={activeEditData}
      />
    </Grid>
  );
};

export default HealthInsurance;
